"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBtnWrapper = exports.StyledBtnLabel = exports.StyledIcon = exports.StyledBtnContent = exports.StyledLink = void 0;
const theme_1 = require("@pulse-web-ui/theme");
require("./button-link.types");
exports.StyledLink = theme_1.styled.a `
  text-decoration: none;
  ${theme_1.mixins.flex({
    justifyContent: 'center',
    alignItems: 'center',
    inline: true,
})};
  ${theme_1.typography.medium18};
  border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius32) !== null && _a !== void 0 ? _a : theme.common.radius; }};
  cursor: pointer;
  width: auto;
  min-width: 128px;
  height: 56px;
  box-sizing: border-box;
  padding: 16px 32px;

  ${({ buttonSize }) => {
    switch (buttonSize) {
        case 's':
            return (0, theme_1.css) `
          width: 130px;
          padding: 12px 32px;
          height: 48px;
        `;
        case 'm':
            return (0, theme_1.css) `
          width: 140px;
          padding: 16px 32px;
          height: 56px;
        `;
        default:
            return null;
    }
}}

  ${({ variant, isLoading, disabled, theme, buttonSize }) => {
    switch (variant) {
        case 'ghost':
            return (0, theme_1.css) `
          color: ${theme.colors.text.primary};
          ${!isLoading &&
                (0, theme_1.css) `
            &:hover:not([disabled]) {
              background-color: ${theme.colors.accent.action.normal};
            }
          `}
        `;
        case 'secondary':
            return (0, theme_1.css) `
          color: ${theme.colors.text.primary};
          border: 1px solid ${theme.colors.neutral[10]};

          ${!disabled &&
                (0, theme_1.css) `
            background: ${theme.colors.neutral[10]};
          `}

          ${!isLoading &&
                (0, theme_1.css) `
            &:hover:not([disabled]) {
              border-color: ${theme.colors.neutral[20]};
              background: ${theme.colors.neutral[20]};
            }
          `}
          ${disabled &&
                (0, theme_1.css) `
            border-color: ${theme.colors.neutral[30]};
          `}
        `;
        case 'secondary-2':
            return (0, theme_1.css) `
          color: ${theme.colors.text.primary};
          border: 1px solid ${theme.colors.neutral[20]};

          ${!isLoading &&
                (0, theme_1.css) `
            &:hover:not([disabled]) {
              background: ${theme.colors.neutral[20]};
            }
          `}
          ${disabled &&
                (0, theme_1.css) `
            border-color: ${theme.colors.neutral[30]};
          `}
        `;
        case 'circle':
        case 'square':
            return (0, theme_1.css) `
          border: 1.2px solid;
          ${variant === 'circle' ? 'border-radius: 50%;' : ''}
          color: ${theme.colors.text.primary};
          width: ${buttonSize === 's' ? '48px' : '56px'};
          min-width: auto;
          padding: 0;

          ${!disabled &&
                (0, theme_1.css) `
            border-color: ${theme.colors.accent.action.normal};
            background: ${theme.colors.accent.action.normal};
          `}

          ${!isLoading &&
                (0, theme_1.css) `
            &:hover:not([disabled]) {
              background-color: ${theme.colors.accent.action.darkened};
              border-color: ${theme.colors.accent.action.darkened};
            }
          `}
          ${disabled &&
                (0, theme_1.css) `
            border-color: ${theme.colors.neutral[30]};
          `}
        `;
        case 'square-secondary':
            return (0, theme_1.css) `
          background-color: ${theme.colors.surface.background}!important;
          border: 1.2px solid ${theme.colors.surface.background}!important;
          color: red | ${theme.colors.text.primary};
          height: ${buttonSize === 's' && variant === 'square-secondary'
                ? '40px'
                : 'auto'};
          width: ${buttonSize === 's' ? '40px' : '56px'};
          min-width: auto;
          padding: 0;

          ${!disabled &&
                (0, theme_1.css) `
            border-color: ${theme.colors.accent.action.normal};
            background: ${theme.colors.accent.action.normal};
          `}

          ${!isLoading &&
                (0, theme_1.css) `
            &:hover:not([disabled]) {
              background-color: ${theme.colors.accent.action.darkened};
              border-color: ${theme.colors.accent.action.darkened};
            }
          `}
          ${disabled &&
                (0, theme_1.css) `
            border-color: ${theme.colors.neutral[30]};
          `}
        `;
        case 'circle-secondary':
            return (0, theme_1.css) `
          border-radius: 50%;
          color: ${theme.colors.icon.primary};
          width: ${buttonSize === 's' ? '48px' : '56px'};
          min-width: auto;
          padding: 0;
          background: ${theme.colors.neutral[10]};
        `;
        case 'text':
            return (0, theme_1.css) `
          ${theme_1.typography.regular18};
          color: ${theme.colors.text.interactive};
          min-width: auto;
          height: auto;
          padding: 0;

          &:hover {
            color: ${theme.colors.text['interactive-clarified']};
          }
        `;
        case 'setting':
            return (0, theme_1.css) `
          ${theme_1.typography.regular16};
          line-height: 24px;
          color: ${theme.colors.text.primary};
          min-width: auto;
          width: auto;
          height: auto;
          padding: 0;

          background: ${theme.colors.accent.action.faded};
          border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius32) !== null && _a !== void 0 ? _a : theme.common.radius; }};
          padding: 4px 12px;

          &:hover {
            background: ${theme.colors.accent.action.clarified};
          }
        `;
        default:
            return (0, theme_1.css) `
          color: ${theme.colors.text.primary};
          ${disabled
                ? (0, theme_1.css) `
                background-color: ${theme.colors.neutral[10]};
              `
                : (0, theme_1.css) `
                background-color: ${theme.colors.accent.action.normal};
                border-color: ${theme.colors.accent.action.normal};
                &:hover {
                  background-color: ${theme.colors.accent.action.darkened};
                  border-color: ${theme.colors.accent.action.darkened};
                }
              `};
        `;
    }
}};

  ${({ disabled, theme }) => disabled &&
    (0, theme_1.css) `
      color: ${theme.colors.text.secondary};
    `}

  ${({ disabled, isLoading }) => (disabled || isLoading) &&
    (0, theme_1.css) `
      cursor: default;
    `}

  ${({ adaptiveWidth }) => adaptiveWidth &&
    (0, theme_1.css) `
      width: 100%;
    `}
`;
exports.StyledBtnContent = theme_1.styled.div `
  ${({ variant }) => theme_1.mixins.flex({
    justifyContent: 'center',
    alignItems: 'center',
    gap: variant === 'square' || variant === 'square-secondary' ? 0 : 8,
    wrap: false,
})};

  ${({ isLoading }) => isLoading &&
    (0, theme_1.css) `
      opacity: 0;
      height: 0;
    `}
`;
exports.StyledIcon = theme_1.styled.div `
  ${theme_1.mixins.flex({
    justifyContent: 'center',
    alignItems: 'center',
})};
  max-width: 24px;
  max-height: 24px;
`;
exports.StyledBtnLabel = theme_1.styled.span `
  ${theme_1.mixins.flex({
    justifyContent: 'center',
    alignItems: 'center',
})};
  ${({ variant }) => variant !== 'text' &&
    (0, theme_1.css) `
      flex-shrink: 0;
    `}
`;
exports.StyledBtnWrapper = theme_1.styled.div `
  ${theme_1.mixins.flex({
    horizontal: false,
    alignItems: 'center',
})};
`;
